export function shouldHandleRecoveryKitHash(hash: string, lastHandledHash: string | null): boolean {
  if (hash !== '#recovery-kit') return false
  return lastHandledHash !== hash
}
